import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Input, message, Space, Tabs, Typography } from 'antd';
import { SaveOutlined, LockOutlined, UserOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { useFetchUserById, useUpdateUser } from '../../hooks/userHooks';
import ChangePasswordModal from './ChangePasswordModal';

const { Title, Text } = Typography;

const UserProfile = () => {
  const currentUser = useSelector(state => state.user);
  const userId = currentUser?.UserID;
  
  const { user, loading, error, refetch } = useFetchUserById(userId);
  const { handleUpdate, isUpdating } = useUpdateUser();
  
  const [form] = Form.useForm();
  const [isPasswordModalVisible, setIsPasswordModalVisible] = useState(false);

  // Set up form values when user data is loaded
  useEffect(() => {
    if (user) {
      form.setFieldsValue({
        Name: user.Name,
        Email: user.Email
      });
    }
  }, [form, user]);

  const saveChanges = async () => {
    try {
      const values = await form.validateFields();
      await handleUpdate(userId, values);
      message.success('Profil mis à jour avec succès');
      refetch();
    } catch (err) {
      message.error('Échec de la mise à jour du profil');
    }
  };

  if (loading) return <p>Chargement...</p>;
  if (error) return <p>Erreur: {error}</p>;
  if (!user) return <p>Aucun utilisateur trouvé</p>;

  return (
    <div>
      <Card 
        title={
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <UserOutlined style={{ marginRight: 10 }} />
              <span>Mon Profil</span>
            </div>
            <Space>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                onClick={saveChanges}
                loading={isUpdating}
              >
                Enregistrer les modifications
              </Button>
              <Button
                icon={<LockOutlined />}
                onClick={() => setIsPasswordModalVisible(true)}
              >
                Changer le mot de passe
              </Button>
            </Space>
          </div>
        }
        bordered={false}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            Name: user.Name,
            Email: user.Email
          }}
        >
          <Title level={5} style={{ marginBottom: 16 }}>Informations Personnelles</Title>
          
          <Form.Item 
            label="Nom" 
            name="Name"
            rules={[{ required: true, message: 'Veuillez saisir votre nom' }]}
          >
            <Input />
          </Form.Item>
          
          <Form.Item 
            label="Email" 
            name="Email"
            rules={[
              { required: true, message: 'Veuillez saisir votre email' },
              { type: 'email', message: 'Veuillez saisir un email valide' }
            ]}
          >
            <Input disabled />
          </Form.Item>
        </Form>
      </Card>

      {/* Change Password Modal */}
      <ChangePasswordModal 
        userId={userId}
        visible={isPasswordModalVisible}
        onCancel={() => setIsPasswordModalVisible(false)}
      />
    </div>
  );
};

export default UserProfile; 